import axios from "axios";

import { notifyError } from "../components/common/notification/NotificationHelper";

export const importService = {
  importFile,
  downloadTemplate
};

function showError(error) {
  const detail = error.response && error.response.data && error.response.data.detail;
  notifyError(detail || "Import failed. Please try again.");
  return null;
}

function importFile(indicator, file, dryRun) {
  const form = new FormData();
  form.append("file", file);
  form.append("dry_run", dryRun ? "true" : "false");

  return axios
    .post("/api/v2/" + indicator + "/import/", form)
    .then(response => response.data)
    .catch(showError);
}

function downloadTemplate(indicator) {
  return axios
    .get("/api/v2/" + indicator + "/import/template/", { responseType: "blob" })
    .then(response => {
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(response.data);
      link.download = indicator + "-import-template.xlsx";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    })
    .catch(showError);
}
